module.exports = __webpack_public_path__ + "img/bsc_05.9d12b383.png";